import type { JSX } from "react";
import { hudState } from "../state/hud/hud.state.ts";

/** The floating status line the tools write to. */
export function HudOverlay(): JSX.Element | null {
  const { message } = hudState.use();

  if (!message) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-x-0 top-3 flex justify-center">
      <output className="max-w-[92%] truncate rounded-full bg-slate-950/85 px-3.5 py-1.5 font-mono text-xs text-slate-100 shadow-lg ring-1 ring-slate-100/10">
        {message}
      </output>
    </div>
  );
}
